import clsx from 'clsx';
import { motion } from 'framer-motion';
import React from 'react';

export function BlurInH3({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const variants1 = {
    hidden: { filter: 'blur(8px)', opacity: 0 },
    visible: { filter: 'blur(0px)', opacity: 1 },
  };
  return (
    <motion.h3
      initial="hidden"
      animate="visible"
      transition={{ duration: 1 }}
      variants={variants1}
      className={clsx(
        'drop-shadow-lg',
        'text-[26px] md:text-[34px] lg:text-[42px] drop-shadow',
        'mb-8 leading-[1.25em]',
        'tracking-[-0.02em]',
        className
      )}
    >
      {children}
    </motion.h3>
  );
}
